import React from "react";

// Monoline architectural icons — 1.75 stroke, square caps, 24×24 base.
// All icons share the same visual DNA so they sit together as a set.

const base = {
  width: 28,
  height: 28,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
};

// 01 — Architectural Design: elevation of a residential volume
export const IconArch = (p) => (
  <svg {...base} {...p} aria-hidden="true">
    <path d="M3 21h18" />
    <path d="M5 21V9l7-5 7 5v12" />
    <path d="M5 13h14" />
    <path d="M10 21v-5h4v5" />
    <path d="M8 10h1.5M14.5 10H16" />
  </svg>
);

// 02 — High-End Interior Layouts: minimal lounge in a framed room
export const IconInterior = (p) => (
  <svg {...base} {...p} aria-hidden="true">
    <path d="M3 5h18v14H3z" />
    <path d="M3 15h18" />
    <path d="M7 15v-3h10v3" />
    <path d="M9 12v-2h6v2" />
    <path d="M12 5v3" />
  </svg>
);

// 03 — Photorealistic 3D Rendering: axonometric wireframe cube
export const IconRender = (p) => (
  <svg {...base} {...p} aria-hidden="true">
    <path d="M12 3 3 7.5 12 12l9-4.5L12 3Z" />
    <path d="M3 7.5V16.5L12 21" />
    <path d="M21 7.5V16.5L12 21" />
    <path d="M12 12V21" />
  </svg>
);

// 04 — Facade & Material Detailing: louvered panel grid
export const IconFacade = (p) => (
  <svg {...base} {...p} aria-hidden="true">
    <path d="M3 3h18v18H3z" />
    <path d="M3 9h18M3 15h18" />
    <path d="M9 3v18M15 3v18" />
    <path d="M6 6v0M18 18v0" />
  </svg>
);

// 05 — Approval Drawings & Liaisoning: stamped document with corner fold
export const IconApproval = (p) => (
  <svg {...base} {...p} aria-hidden="true">
    <path d="M5 3h10l4 4v14H5z" />
    <path d="M15 3v4h4" />
    <path d="m8.5 13 2.2 2.2L15.5 10" />
    <path d="M8 18h8" />
  </svg>
);
